import { atom } from "recoil";

const estimateImageAtom = atom({
    key: "estimateImageValue",
    default: []
});

export default estimateImageAtom;